// extracted by mini-css-extract-plugin
module.exports = {"principios":"principios_principios__363Rm","img_container":"principios_img_container__1CW7i"};